/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : '',
        link : '/dashboards/competitors',
        tooltip: 'Dashboard',
        role: ['user-lineup'],
        classes: {
            icon: 'fas fa-chart-line'
        },
                
        children: [
           
        ]
    },
    {
        id   : 'lineup',
        title: 'LineUp',
        type : 'basic',
        icon : '',
        classes: {
            icon: 'fas fa-location-crosshairs'
        },
        link : '/operational/lineup',
        tooltip: 'Line Up',
        role: ['user-lineup'],
        children: [
           
        ]
    },
    // {
    //     id   : 'master-data',
    //     title: 'Master Data',
    //     type : 'aside',
    //     icon : 'feather:database',
    //     tooltip: 'Master',
    //     children: [
           
    //     ]
    // },
             {
                id   : 'berth-window',
                title: 'Berth Window',
                type : 'basic',
                icon : '',
                classes: {
                    icon: 'fas fa-clipboard-list'
                },
                link : '/master-data/berth-window',
                tooltip: 'Berth Window',
                role: ['admin'],
                children: [],
                
            },
            {
                id   : 'my-fleet',
                title: 'My Fleet',
                type : 'basic',
                icon : '',
                tooltip: 'My Fleet',
                classes: {
                    icon: 'fas fa-ship'
                },
                link : '/master-data/my-fleet',
                children: []
            },
    // {
    //     id   : 'monitoring',
    //     title: 'Monitoring',
    //     type : 'basic',
    //     icon : '',
    //     link : '',
    //     tooltip: 'Monitoring',
    //     classes: {
    //         icon: 'fas fa-heart-pulse   '
    //     },
                
    //     children: [
           
    //     ]
    // }
];


export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : '',
        link : '/dashboards/bw-integrity',
        tooltip: 'Dashboard',
        classes: {
            icon: 'fas fa-chart-line'
        },
                
        children: [
           
        ],
        role: ['admin', 'user-lineup']

    },
    {
        id   : 'myfleet',
        title: 'My Fleet',
        type : 'basic',
        icon : '',
        link : '/dashboards/my-fleet',
        tooltip: 'My Fleet',
        classes: {
            icon: 'fas fa-layer-group'
        },
                
        children: [
           
        ],
        role: ['admin', 'user-lineup', 'owner', 'admin2']

    },
    {
        id   : 'lineup',
        title: 'LineUp',
        type : 'basic',
        icon : '',
        classes: {
            icon: 'fas fa-location-crosshairs'
        },
        link : '/operational/lineup',
        tooltip: 'Line Up',
        children: [
           
        ],
        role: ['admin', 'user-lineup', 'owner', 'admin2']
    },
    {
        id   : 'cargo-readiness',
        title: 'CargoReadiness',
        type : 'basic',
        icon : '',
        classes: {
            icon: 'fas fa-clipboard-check'
        },
        link : '/operational/cargo-readiness',
        tooltip: 'Cargo Readiness',
        children: [
           
        ],
        role: ['admin', 'user-cargo']
    },
    // {
    //     id   : 'master-data',
    //     title: 'Master Data',
    //     type : 'aside',
    //     icon : 'feather:database',
    //     tooltip: 'Master',
    //     children: [
           
    //     ]
    // },
            {
                id   : 'my-fleet',
                title: 'My Fleet',
                type : 'basic',
                icon : '',
                tooltip: 'My Fleet',
                classes: {
                    icon: 'fas fa-ship'
                },
                link : '/master-data/my-fleet',
                children: [],
                role: ['admin', 'owner']
            },
            {
                id   : 'berth-window',
                title: 'Berth Window',
                type : 'basic',
                icon : '',
                classes: {
                    icon: 'fas fa-calendar-check'
                },
                link : '/master-data/berth-window',
                tooltip: 'Berth Window',
                children: [],
                role: ['admin']
            },
        {
            id   : 'monitoring',
            title: 'Monitoring',
            type : 'basic',
            icon : '',
            link : '',
            tooltip: 'Monitoring',
            classes: {
                icon: 'fas fa-heart-pulse   '
            },
                    
            children: [
            
            ],
            role: ['admin']
        }
];



export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
